/* SELL MY PHONE – PERMANENT DROPDOWN LOGIC (SHOPIFY SAFE) */
(function () {

  const DATA = {
    "Apple iPhone": {
      "iPhone 17": ["Standard","Plus","Pro","Pro Max"],
      "iPhone 16": ["Standard","Plus","Pro","Pro Max"],
      "iPhone 15": ["Standard","Plus","Pro","Pro Max"],
      "iPhone 14": ["Standard","Plus","Pro","Pro Max"]
    },
    "Samsung": {
      "Galaxy S24": ["Standard","Plus","Ultra"],
      "Galaxy S23": ["Standard","Plus","Ultra"],
      "Galaxy A Series": ["A55","A35","A25"]
    },
    "Google Pixel": {
      "Pixel 8": ["Standard","Pro"],
      "Pixel 7": ["Standard","Pro"]
    }
  };

  function initSellPhoneForm() {
    const brand   = document.querySelector("#smp_brand");
    const model   = document.querySelector("#smp_model");
    const variant = document.querySelector("#smp_variant");

    if (!brand || !model || !variant) return;

    model.disabled = true;
    variant.disabled = true;

    brand.addEventListener("change", function () {
      model.innerHTML = `<option value="">Select model</option>`;
      variant.innerHTML = `<option value="">Select variant</option>`;
      variant.disabled = true;

      if (!DATA[this.value]) {
        model.disabled = true;
        return;
      }

      Object.keys(DATA[this.value]).forEach(m => {
        model.insertAdjacentHTML("beforeend", `<option>${m}</option>`);
      });

      model.disabled = false;
    });

    model.addEventListener("change", function () {
      variant.innerHTML = `<option value="">Select variant</option>`;

      if (!DATA[brand.value] || !DATA[brand.value][this.value]) {
        variant.disabled = true;
        return;
      }

      DATA[brand.value][this.value].forEach(v => {
        variant.insertAdjacentHTML("beforeend", `<option>${v}</option>`);
      });

      variant.disabled = false;
    });
  }

  /* Shopify section reload safe */
  document.addEventListener("DOMContentLoaded", initSellPhoneForm);
  document.addEventListener("shopify:section:load", initSellPhoneForm);

})();
